module.exports = __webpack_public_path__ + "static/media/balao.89421cfa.png";